import Gator from 'gator';

let noSelectedEvent;
let submitButton;
let eventDataset;
let counter;

// Conference - Check events that were checked before
let eventForm = document.getElementById('event-form');
let form = document.querySelector('.conference-form');

if (eventForm && form) {
    noSelectedEvent = eventForm.querySelector('#no-selected-event');
    submitButton = eventForm.querySelector('button[type=submit]');
    eventDataset = eventForm.dataset;
    counter = [...document.querySelectorAll('.conference__counter')];

    form.addEventListener('submit', () => {
        eventForm.classList.add('conference__form--sending');
    });

    const eventsToCheck = eventDataset.events;
    if (eventsToCheck) {
        const eventIds = eventsToCheck.split(',');
        eventIds.forEach(event => {
            const element = document.getElementById(`input-register-${event}`);
            if (element) {
                element.checked = true;
            }
        });

        toggleForm(true);
    }
}

// Conference - Check all checkboxes (in case form is already filled out)
[...document.querySelectorAll('.conference-register-checkbox input')].forEach(checkbox => {
    changeEventSelectionState(checkbox, false);
});

// Conference - Workshop is selected/deselected for registration
Gator(document).on('change', '.conference-register-checkbox input', function() {
    changeEventSelectionState(this, true);
});

function changeEventSelectionState(checkboxElement, removeIfChecked) {
    const checked = checkboxElement.checked;
    const id = checkboxElement.parentElement.parentElement.parentElement.id;
    const selectedEvent = document.getElementById(`selected-event-${id}`);

    if (!selectedEvent) {
        return;
    }

    const hiddenInputText = selectedEvent.querySelector('.hidden-input-text');
    const hiddenInputPrice = selectedEvent.querySelector('.hidden-input-price');
    const hiddenInputNameWithCosts = selectedEvent.querySelector('.hidden-input-nameWithCosts');
    const hiddenInputId = selectedEvent.querySelector('.hidden-input-id');
    const summedCount = parseInt(eventDataset.count);
    const count = parseInt(counter[0].dataset.count);
    let newSummedCount = summedCount;
    let newCount = count;

    if (checked) {
        selectedEvent.classList.add('selected');
        hiddenInputText.setAttribute('name', 'events[]');
        hiddenInputPrice.setAttribute('name', 'eventPrices[]');
        if (hiddenInputNameWithCosts.getAttribute('value') != '') {
            hiddenInputNameWithCosts.setAttribute('name', 'nameWithCosts[]');
        }
        hiddenInputId.setAttribute('name', 'eventIds[]');
        newSummedCount = newSummedCount + 1;
        newCount = newCount + 1;
    } else if (removeIfChecked) {
        selectedEvent.classList.remove('selected');
        hiddenInputText.removeAttribute('name');
        hiddenInputPrice.removeAttribute('name');
        hiddenInputNameWithCosts.removeAttribute('name');
        hiddenInputId.removeAttribute('name');
        newSummedCount = newSummedCount - 1;
        newCount = newCount - 1;
    }

    if (newCount < 0) {
        newCount = 0;
    }
    if (newSummedCount < 0) {
        newSummedCount = 0;
    }

    counter.forEach(element => {
        element.dataset.count = newCount;
    });

    eventDataset.count = newSummedCount;

    if (newSummedCount == 0) {
        toggleForm(false);
    } else if (removeIfChecked) {
        toggleForm(true);
    }
}

function toggleForm(enable) {
    noSelectedEvent.style.display = enable ? 'none' : 'block';
    submitButton.disabled = !enable;
    counter.forEach(element => {
        element.classList[enable ? 'remove' : 'add']('disabled');
    });
}
